export const KIROVSKI_DISTRICT = 324
export const CHKALOVSKI_DISTRICT = 2609
export const COMMON_DISTRICT = 2656

export default [KIROVSKI_DISTRICT, CHKALOVSKI_DISTRICT, COMMON_DISTRICT]
